import { FaLinkedinIn } from "react-icons/fa";

export default function LinkedinIcon({ size }) {
    return <FaLinkedinIn size={size} />;
}